export const REQUEST_STATUS_PRESETS = {
  approved: {
    key: 'approved',
    routeKey: 'aprobadas',
    label: 'Solicitudes aprobadas',
    lead: 'Retoma solicitudes listas para la segunda etapa y completá documentación, medio de cobro y firma.',
    searchLabel: 'Buscar solicitudes aprobadas',
    searchHint: 'Esta vista inicia filtrada por solicitudes aprobadas, pero podés quitar el filtro para explorar el resto.',
    eyebrow: 'Segunda etapa',
    statuses: [14, 8]
  },
  observed: {
    key: 'observed',
    routeKey: 'observadas',
    label: 'Solicitudes observadas',
    lead: 'Revisá solicitudes con observaciones pendientes para retomar el seguimiento del cliente.',
    searchLabel: 'Buscar solicitudes observadas',
    searchHint: 'Esta vista inicia filtrada por solicitudes observadas, pero podés quitar el filtro para explorar el resto.',
    eyebrow: 'Seguimiento',
    statuses: [13, 11, 20]
  },
  rejected: {
    key: 'rejected',
    routeKey: 'rechazadas',
    label: 'Solicitudes rechazadas',
    lead: 'Consultá solicitudes cerradas por rechazo automático, rechazo analista o desistimiento del cliente.',
    searchLabel: 'Buscar solicitudes rechazadas',
    searchHint: 'Esta vista inicia filtrada por solicitudes rechazadas, pero podés quitar el filtro para explorar el resto.',
    eyebrow: 'Historial',
    statuses: [3, 4, 7, 96, 97, 98, 99]
  },
  waitingSettlement: {
    key: 'waitingSettlement',
    routeKey: 'esperando-liquidacion',
    label: 'Esperando liquidación',
    lead: 'Seguimiento de solicitudes en análisis de pago o listas para pasar a liquidación.',
    searchLabel: 'Buscar solicitudes esperando liquidación',
    searchHint: 'Esta vista inicia filtrada por solicitudes en etapa de liquidación, pero podés quitar el filtro para explorar el resto.',
    eyebrow: 'Liquidación',
    statuses: [9, 21]
  },
  riskAnalysis: {
    key: 'riskAnalysis',
    routeKey: 'analisis-riesgo',
    label: 'En análisis de riesgo',
    lead: 'Seguimiento de solicitudes enviadas a la financiera y pendientes de revisión por el equipo de riesgo.',
    searchLabel: 'Buscar solicitudes en análisis de riesgo',
    searchHint: 'Esta vista inicia filtrada por solicitudes en análisis de riesgo, pero podés quitar el filtro para explorar el resto.',
    eyebrow: 'Riesgo',
    statuses: [2]
  }
};

export const DEFAULT_REQUEST_PRESET_KEY = 'approved';

export const REQUEST_PRESET_ROUTE_MAP = Object.values(REQUEST_STATUS_PRESETS).reduce((acc, preset) => {
  acc[preset.routeKey] = preset.key;
  return acc;
}, {});

export const resolveRequestPreset = (rawRouteKey) => {
  if (!rawRouteKey) {
    return REQUEST_STATUS_PRESETS[DEFAULT_REQUEST_PRESET_KEY];
  }

  const presetKey = REQUEST_PRESET_ROUTE_MAP[rawRouteKey] || rawRouteKey;
  return REQUEST_STATUS_PRESETS[presetKey] || REQUEST_STATUS_PRESETS[DEFAULT_REQUEST_PRESET_KEY];
};

export const getRequestPresetRoute = (presetKey) => {
  const preset = REQUEST_STATUS_PRESETS[presetKey];
  return preset ? `/solicitudes/${preset.routeKey}` : '/solicitudes';
};
